module.exports = __webpack_public_path__ + "img/AllApplicants.823925db.svg";